/** Stable, portable identifiers (UUID v4). Never rely on DB-generated ids. */
export type Id = string;

export function createId(): Id {
  return globalThis.crypto.randomUUID();
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function isId(value: unknown): value is Id {
  return typeof value === "string" && UUID_RE.test(value);
}
